import * as yup from 'yup';
export const EditStudentInvoiceSchema = yup.object().shape({
  start_date: yup.string().required('Required'),
  end_date: yup.string().required('Required'),
  total: yup.string().required('Required'),
  status: yup.number().required('Required'),
  user: yup.string().required('Required'),
});
